"use client";

import React from "react";
import { useGlobalChat } from "../contexts/ChatContext";

interface ChatHeaderProps {
  title?: string;
  logo?: string;
}

const ChatHeader: React.FC<ChatHeaderProps> = ({
  title = "Chat Support",
  logo,
}) => {
  const { minimizeChat, closeChat, isMinimized, maximizeChat } =
    useGlobalChat();

  return (
    <div
      className="flex items-center p-3 bg-blue-500 text-white"
      role="heading"
      aria-level={1}
    >
      {logo && <img src={logo} alt="Chat Logo" className="h-6 w-auto mr-2" />}
      <h3 className="text-base font-semibold flex-1">{title}</h3>
      <div className="flex gap-2">
        {isMinimized ? (
          <button
            onClick={maximizeChat}
            className="p-1 hover:bg-blue-600 rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-300"
            aria-label="Maximize chat"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="5 12 12 5 19 12"></polyline>
            </svg>
          </button>
        ) : (
          <button
            onClick={minimizeChat}
            className="p-1 hover:bg-blue-600 rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-300"
            aria-label="Minimize chat"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="5 9 12 16 19 9"></polyline>
            </svg>
          </button>
        )}
        <button
          onClick={closeChat}
          className="p-1 hover:bg-blue-600 rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-300"
          aria-label="Close chat"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
    </div>
  );
};

export default ChatHeader;
